import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../route';

// TEMPORARY redirect — remove after all tenants migrate to OMS v3.
// The OMS v3 list moved to /sales-orders; stale bookmarks must keep working.
// The v3 page components still live in this folder (imported by the
// /sales-orders route module).
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders-v3',
  beforeLoad: () => {
    throw redirect({ to: '/sales-orders', search: true });
  },
});
